export default __webpack_public_path__ + "static/realWorldImg5-b2d2c3142f614ff425dcbf503a580747.webp";